import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import * as _ from 'lodash';

import * as utils from 'utils/utils';
import { segmentsData } from '../../../product-details/segments-data-stub';
import { getAssetThumbnail, isImageFileType } from 'shared/digital-assets/digital-asset-helpers';
import { getPriceSheets } from 'shared/price-sheet/price-sheet-helpers';

import { IconsDropdownComponent } from 'shared/dropdown/icons-dropdown/icons-dropdown.component';
import {ProductPanelComponent} from '../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'ecommerce-marquee',
  templateUrl: 'marquee.component.html',
  styleUrls: ['marquee.component.scss'],
})
export class MarqueeComponent implements OnInit, OnChanges {
  @Input() itemDetail: any;

  @Input() partNumber: any;

  @Input() description: string;

  @Input() priceSheets: Array<any>;

  @Output() selectLanguage: EventEmitter<any> = new EventEmitter();

  @ViewChild(IconsDropdownComponent, {static: false})
  priceSheetsDropdown: IconsDropdownComponent | void;

  assetBigImageUrl: string = '';
  imageAssets: Array<any>;
  selectedPriceSheet: any;
  priceSheetsItems: Array<any> = [];

  priceNames: Array<string> = [
    'RET', 'JBR', 'RMP', 'UNL'
  ];

  priceSegments: Array<any>;
  descriptionItem: any;
  addToCartQuantity: number = 1;
  selectedAsset: any;
  selectedLanguage: string = 'EN';
  languageItems: Array<any>;

  ngOnInit() {
    this.languageItems = utils.getAvailableLanguages();
    this.descriptionItem = _.find(segmentsData.descriptions, ['item_name', 'descriptions.EXT']);
    this.priceSegments = _.filter(segmentsData.prices, (item: any) => {
      return _.includes(this.priceNames, item.item_name);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemDetail && changes.itemDetail.currentValue) {
      this.separateImageAssets();
    }
    if (changes.priceSheets && changes.priceSheets.currentValue) {
      this.addDropdownPriceSheets();
    }
  }

  // handlers
  onThumbnailClick(asset: any) {
    this.selectedAsset = asset;
    this.assetBigImageUrl = getAssetThumbnail(asset, 'big');
  }

  onBigImageClick() {
    if (this.selectedAsset?.download_link) {
      window.open(this.selectedAsset.download_link, '_blank');
    }
  }

  onPriceSheetChange(priceSheet: any) {
    this.selectedPriceSheet = priceSheet;
  }

  addToCartQuantityClick(num: number) {
    if (this.addToCartQuantity === 1 && num === -1) { return; }
    this.addToCartQuantity += num;
  }

  onLanguageChange(event: any) {
    this.selectedLanguage = event.code;
    this.selectLanguage.emit(this.selectedLanguage);
  }

  // public
  getAssetThumbnail(asset: any): string {
    return getAssetThumbnail(asset);
  }

  getDescription(): string {
    return utils.getItemProperty(
      this.descriptionItem,
      `${this.descriptionItem.item_name}.${this.selectedLanguage}`,
      this.itemDetail
    );
  }

  getPrice(item: any): string | null {
    if (!this.priceSheets) { return ''; }
    if (!this.selectedPriceSheet) { return ''; }
    const currency = utils.getItemProperty(
      item,
      `prices.${this.selectedPriceSheet.id}.${item.item_name}.USD`,
      this.itemDetail
    );
    if (currency && currency.price) {
      return (Math.floor(+currency.price * 100) / 100).toFixed(2);
    } else {
      return '';
    }
  }

  // private
  private separateImageAssets(): void {
    this.imageAssets = _.filter(_.get(this.itemDetail, 'digitalAssets', []), isImageFileType);
    if (this.imageAssets) {
      const primaryPhoto = _.find(this.imageAssets, (item: any) => {
        return item.asset_type === 'P04';
      });
      this.selectedAsset = primaryPhoto ? primaryPhoto : {};
      this.assetBigImageUrl = getAssetThumbnail(this.selectedAsset, 'big');
    }
  }

  private addDropdownPriceSheets(): void {
    this.priceSheetsItems = getPriceSheets(this.priceSheets);
    _.defer(() => {
      if (this.priceSheetsDropdown) {
        this.priceSheetsDropdown.setActive(this.priceSheetsItems[0].id);
      }
    });
  }
}
